"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletApproverWrapperSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
// import { isSwitchStatement } from "typescript";
const WalletApproveInterface_1 = require("../WalletApproveInterface");
const initialApprovalState = Object.assign({}, WalletApproveInterface_1.defaultApprovalState);
exports.walletApproverWrapperSlice = (0, toolkit_1.createSlice)({
    name: "walletApproverWrapper",
    initialState: initialApprovalState,
    reducers: {
        getApproval: (state, action) => {
            state.approvals[`${action.payload.userAddress}|${action.payload.contractAddress}|${action.payload.currency}`] = action.payload.allocation;
        },
        tranasctionIdReceived: (state, action) => {
            state.transactionId = action.payload.transactionId;
        },
        checkingApproval: (state) => {
            state.isCheckingApproval = true;
            state.isApproving = false;
            state.isApproved = false;
        },
        approving: (state) => {
            state.isCheckingApproval = false;
            state.isApproving = true;
            state.isApproved = false;
            state.showApprovalModal = true;
        },
        approved: (state) => {
            state.isCheckingApproval = false;
            state.isApproving = false;
            state.isApproved = true;
        },
        approvalChecked: (state) => {
            state.isCheckingApproval = false;
            state.isApproving = false;
            state.isApproved = false;
        },
        resetWalletApproveState: (state) => {
            state.isCheckingApproval = false;
            state.isApproving = false;
            state.isApproved = false;
        },
        approvalFailed: (state) => {
            state.isCheckingApproval = false;
            state.isApproving = false;
            state.isApproved = false;
            state.status = "failed";
        },
        approvalFound: (state) => {
            state.status = "success";
            state.isCheckingApproval = false;
            state.isApproving = false;
            state.isApproved = true;
        },
        resetApprovalModal: (state) => {
            state.showApprovalModal = false;
        },
    },
});
//# sourceMappingURL=WalletApproverWrapperSlice.js.map